const numberFormats = {
  "en": {
    currency: {
      style: "currency",
      currency: "CZK",
      currencyDisplay: "symbol"
    }
  },
  'cs': {
    currency: {
      style: "currency",
      currency: "CZK",
      currencyDisplay: "symbol"
    }
  }
//   'sk': {
//     currency: {
//       style: "currency",
//       currency: "EUR",
//       currencyDisplay: "symbol"
//     }
//   }
};
export default numberFormats
